import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'unb-projeto-inicial-home',
    templateUrl: './home.html'
})
export class HomeComponent {

  // construtor
  constructor( public router: Router) {

   }


}
